import type { HTMLAttributes } from 'react';
import { cx } from '../cx';
import styles from './Badge.module.css';

// Badge — DESIGN_SYSTEM §12 row 10: a count (unread alerts, ads in a tab). Counts only, never words. The
// element reads exactly the number (D-019); what the number means belongs to the control around it — the
// alerts button's accessible name, the tab's label ("Ads 3").

export type BadgeTone = 'neutral' | 'alert' | 'primary';

export interface BadgeProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'children'> {
  children: number | string;
  tone?: BadgeTone;
  testID?: string;
}

export function Badge({ children, tone = 'neutral', testID, className, ...rest }: BadgeProps) {
  return (
    <span
      className={cx(
        styles.badge,
        tone === 'alert' && styles.alert,
        tone === 'primary' && styles.primary,
        className,
      )}
      data-testid={testID}
      {...rest}
    >
      {children}
    </span>
  );
}
